import { Injectable, Inject } from '@angular/core';
import { Reinforcement, Profile } from '@icc/window-door/types';
import { ReinforcementsService } from './reinforcements.service';
import { StateService } from '@icc/shared/state.service';
import { ModalService } from '@icc/configurator/shared';
import {APP_CONFIG, AppConfigFactory} from '@icc/shared/config';
import { ReinforcementsListPageComponent } from './reinforcements-list-page/reinforcements-list-page.component';
import { TranslateService } from "@icc/shared";

@Injectable()
export class ReinforcementsModalService {
    constructor(
        private reinforcementsService: ReinforcementsService,
        private translateService: TranslateService,
        private stateService: StateService,
        private modalService: ModalService,
        @Inject(APP_CONFIG) private config: AppConfigFactory,
    ) {}

    async openReinforcementsModal(
        profileId: Profile['id'],
        selectedReinforcement: Reinforcement | null,
        currency?: any,
        length?: number,
    ): Promise<Reinforcement | false> {
        let reinforcements = (this.reinforcementsService.reinforcements as Reinforcement[]).filter(el =>
            el.profiles && el.profiles.indexOf(Number(profileId)) > -1
        );
        if (length != null) {
            reinforcements = reinforcements.filter(r =>
                (r.min_length_profile == null || r.min_length_profile <= length)
                && (r.max_length_profile == null || r.max_length_profile >= length)
            );
        }
        reinforcements.unshift({
            id: null,
            name: this.translateService.instant('INTERFACE|Brak'),
            price: 0
        });
        const modalInstance = this.modalService.open({
            component: 'reinforcementsModal',
            pageComponent: ReinforcementsListPageComponent,
            resolve: {
                reinforcements: () => reinforcements,
                selectedReinforcement: () => selectedReinforcement,
                currency: () => currency || this.config().currency || this.stateService.state.offers[0].doc.currency,
            },
        });

        return modalInstance.result;
    }
}
